import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MissingBoxState {
  records: any[];
  total: number;
  page: number;
  limit: number;
  query: string;
  sortBy: string;
  defaultSort: 'asc' | 'desc';
  showModal: boolean;
  showDeleteModal: boolean;
  currentRecord: any;
}

const initialState: MissingBoxState = {
  records: [],
  total: 0,
  page: 0,
  limit: 20,
  query: '',
  sortBy: 'createdAt',
  defaultSort: 'desc',
  showModal: false,
  showDeleteModal: false,
  currentRecord: null,
};

const missingBoxSlice = createSlice({
  name: 'missingBox',
  initialState,
  reducers: {
    setRecords: (state, action: PayloadAction<any[]>) => {
      state.records = action.payload;
    },
    setTotal: (state, action: PayloadAction<number>) => {
      state.total = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setLimit: (state, action: PayloadAction<number>) => {
      state.limit = action.payload;
    },
    setQuery: (state, action: PayloadAction<string>) => {
      state.query = action.payload;
    },
    setSortBy: (state, action: PayloadAction<string>) => {
      state.sortBy = action.payload;
    },
    setDefaultSort: (state, action: PayloadAction<'asc' | 'desc'>) => {
      state.defaultSort = action.payload;
    },
    setShowModal: (state, action: PayloadAction<boolean>) => {
      state.showModal = action.payload;
    },
    setShowDeleteModal: (state, action: PayloadAction<boolean>) => {
      state.showDeleteModal = action.payload;
    },
    setCurrentRecord: (state, action: PayloadAction<any>) => {
      state.currentRecord = action.payload;
    },
  },
});

export const {
  setRecords,
  setTotal,
  setPage,
  setLimit,
  setQuery,
  setSortBy,
  setDefaultSort,
  setShowModal,
  setShowDeleteModal,
  setCurrentRecord,
} = missingBoxSlice.actions;

export default missingBoxSlice.reducer;
